import { c as _c } from "react/compiler-runtime";
import { AdminIcon, BrowserIcon, FileAttachment01Icon, GitPullRequestIcon, HomeLineIcon, Mail04Icon, MessageDotsSquareIcon, Sale01Icon, User03Icon } from '@systemeio/icons';
import { pageRoute } from 'shared/constants/routes.constants';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { usePermission } from 'shared/hooks/use-permission';
import { useRouter } from 'shared/hooks/use-router';
import useUser from 'shared/hooks/use-user';
import { formUrl } from 'shared/utils/links/form-url';
import type { MenuItem } from '../types/menu-item';
export const useMenuItems = () => {
  const $ = _c(408);
  const {
    t
  } = useLocoTranslation();
  const {
    isWsAssistant,
    isStudent
  } = useUser();
  const {
    pathname
  } = useRouter();
  const {
    pagePermissions,
    isReady
  } = usePermission();
  let t0;
  if ($[0] !== pathname) {
    t0 = url => pathname.includes(url);
    $[0] = pathname;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const regularIsActiveCheck = t0;
  let t1;
  if ($[2] !== pagePermissions) {
    t1 = route => Boolean(pagePermissions[pageRoute[route]]);
    $[2] = pagePermissions;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const hasPermission = t1;
  let t2;
  if ($[4] !== t) {
    t2 = t("header.top_menu.dashboard");
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t) {
    t3 = t("header.top_menu.main_dashboard");
    $[6] = t;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const t4 = hasPermission("Dashboard");
  let t5;
  if ($[8] !== pathname) {
    t5 = url_0 => pathname === url_0;
    $[8] = pathname;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t3 || $[11] !== t4 || $[12] !== t5) {
    t6 = {
      name: t3,
      href: pageRoute.Dashboard,
      shouldRender: t4,
      isActive: t5,
      dataTestId: "dashboard-main-link"
    };
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t) {
    t7 = t("header.top_menu.affiliate_dashboard");
    $[14] = t;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const t8 = hasPermission("AffiliateDashboard");
  let t9;
  if ($[16] !== regularIsActiveCheck || $[17] !== t7 || $[18] !== t8) {
    t9 = {
      name: t7,
      href: pageRoute.AffiliateDashboard,
      shouldRender: t8,
      isActive: regularIsActiveCheck,
      dataTestId: "dashboard-affiliate-link"
    };
    $[16] = regularIsActiveCheck;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t) {
    t10 = t("header.top_menu.student_dashboard");
    $[20] = t;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== isStudent) {
    t11 = isStudent ? formUrl("/school", false) ?? "" : formUrl("/school?tab=explore_courses", false) ?? "";
    $[22] = isStudent;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== isStudent || $[25] !== regularIsActiveCheck || $[26] !== t10 || $[27] !== t11) {
    t12 = {
      name: t10,
      shouldRender: isStudent,
      href: t11,
      isActive: regularIsActiveCheck,
      dataTestId: "dashboard-student-link"
    };
    $[24] = isStudent;
    $[25] = regularIsActiveCheck;
    $[26] = t10;
    $[27] = t11;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== t) {
    t13 = t("header.top_menu.agency_dashboard");
    $[29] = t;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  const t14 = hasPermission("AgencyUsers");
  let t15;
  if ($[31] !== pathname) {
    t15 = () => pathname.includes("/agency-center");
    $[31] = pathname;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== t13 || $[34] !== t14 || $[35] !== t15) {
    t16 = {
      name: t13,
      href: pageRoute.AgencyUsers,
      shouldRender: t14,
      isActive: t15,
      dataTestId: "dashboard-agency-link"
    };
    $[33] = t13;
    $[34] = t14;
    $[35] = t15;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== t12 || $[38] !== t16 || $[39] !== t6 || $[40] !== t9) {
    t17 = [t6, t9, t12, t16];
    $[37] = t12;
    $[38] = t16;
    $[39] = t6;
    $[40] = t9;
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  let t18;
  if ($[42] !== t17 || $[43] !== t2) {
    t18 = {
      id: "dashboard",
      name: t2,
      dropdownItems: t17,
      mobileIconRenderer: _temp
    };
    $[42] = t17;
    $[43] = t2;
    $[44] = t18;
  } else {
    t18 = $[44];
  }
  let t19;
  if ($[45] !== t) {
    t19 = t("header.top_menu.crm");
    $[45] = t;
    $[46] = t19;
  } else {
    t19 = $[46];
  }
  let t20;
  if ($[47] !== t) {
    t20 = t("header.top_menu.contacts");
    $[47] = t;
    $[48] = t20;
  } else {
    t20 = $[48];
  }
  const t21 = isWsAssistant ? pageRoute.AssistantContacts : pageRoute.Contacts;
  const t22 = isWsAssistant ? hasPermission("AssistantContacts") : hasPermission("Contacts");
  let t23;
  if ($[49] !== regularIsActiveCheck || $[50] !== t20 || $[51] !== t21 || $[52] !== t22) {
    t23 = {
      name: t20,
      href: t21,
      isActive: regularIsActiveCheck,
      shouldRender: t22,
      dataTestId: "crm-contacts-link"
    };
    $[49] = regularIsActiveCheck;
    $[50] = t20;
    $[51] = t21;
    $[52] = t22;
    $[53] = t23;
  } else {
    t23 = $[53];
  }
  let t24;
  if ($[54] !== t) {
    t24 = t("header.top_menu.tags");
    $[54] = t;
    $[55] = t24;
  } else {
    t24 = $[55];
  }
  const t25 = hasPermission("Tags");
  let t26;
  if ($[56] !== regularIsActiveCheck || $[57] !== t24 || $[58] !== t25) {
    t26 = {
      name: t24,
      href: pageRoute.Tags,
      isActive: regularIsActiveCheck,
      shouldRender: t25,
      dataTestId: "crm-tags-link"
    };
    $[56] = regularIsActiveCheck;
    $[57] = t24;
    $[58] = t25;
    $[59] = t26;
  } else {
    t26 = $[59];
  }
  let t27;
  if ($[60] !== t) {
    t27 = t("header.top_menu.crm_pipeline");
    $[60] = t;
    $[61] = t27;
  } else {
    t27 = $[61];
  }
  const t28 = hasPermission("CrmPipeline");
  let t29;
  if ($[62] !== regularIsActiveCheck || $[63] !== t27 || $[64] !== t28) {
    t29 = {
      name: t27,
      href: pageRoute.CrmPipeline,
      isActive: regularIsActiveCheck,
      shouldRender: t28,
      dataTestId: "crm-pipeline-link"
    };
    $[62] = regularIsActiveCheck;
    $[63] = t27;
    $[64] = t28;
    $[65] = t29;
  } else {
    t29 = $[65];
  }
  let t30;
  if ($[66] !== t) {
    t30 = t("header.top_menu.calendar");
    $[66] = t;
    $[67] = t30;
  } else {
    t30 = $[67];
  }
  const t31 = hasPermission("Calendar");
  let t32;
  if ($[68] !== regularIsActiveCheck || $[69] !== t30 || $[70] !== t31) {
    t32 = {
      name: t30,
      href: pageRoute.Calendar,
      isActive: regularIsActiveCheck,
      shouldRender: t31,
      dataTestId: "crm-calendar-link"
    };
    $[68] = regularIsActiveCheck;
    $[69] = t30;
    $[70] = t31;
    $[71] = t32;
  } else {
    t32 = $[71];
  }
  let t33;
  if ($[72] !== t) {
    t33 = t("header.top_menu.helpdesk");
    $[72] = t;
    $[73] = t33;
  } else {
    t33 = $[73];
  }
  const t34 = hasPermission("Helpdesk");
  let t35;
  if ($[74] !== regularIsActiveCheck || $[75] !== t33 || $[76] !== t34) {
    t35 = {
      name: t33,
      href: pageRoute.Helpdesk,
      isActive: regularIsActiveCheck,
      shouldRender: t34,
      dataTestId: "crm-helpdesk-link"
    };
    $[74] = regularIsActiveCheck;
    $[75] = t33;
    $[76] = t34;
    $[77] = t35;
  } else {
    t35 = $[77];
  }
  let t36;
  if ($[78] !== t23 || $[79] !== t26 || $[80] !== t29 || $[81] !== t32 || $[82] !== t35) {
    t36 = [t23, t26, t29, t32, t35];
    $[78] = t23;
    $[79] = t26;
    $[80] = t29;
    $[81] = t32;
    $[82] = t35;
    $[83] = t36;
  } else {
    t36 = $[83];
  }
  let t37;
  if ($[84] !== t19 || $[85] !== t36) {
    t37 = {
      id: "crm",
      name: t19,
      dropdownItems: t36,
      mobileIconRenderer: _temp2
    };
    $[84] = t19;
    $[85] = t36;
    $[86] = t37;
  } else {
    t37 = $[86];
  }
  let t38;
  if ($[87] !== t) {
    t38 = t("header.top_menu.sites");
    $[87] = t;
    $[88] = t38;
  } else {
    t38 = $[88];
  }
  let t39;
  if ($[89] !== t) {
    t39 = t("header.top_menu.website");
    $[89] = t;
    $[90] = t39;
  } else {
    t39 = $[90];
  }
  const t40 = hasPermission("Websites");
  let t41;
  if ($[91] !== regularIsActiveCheck || $[92] !== t39 || $[93] !== t40) {
    t41 = {
      name: t39,
      href: pageRoute.Websites,
      shouldRender: t40,
      isActive: regularIsActiveCheck,
      dataTestId: "sites-website-link"
    };
    $[91] = regularIsActiveCheck;
    $[92] = t39;
    $[93] = t40;
    $[94] = t41;
  } else {
    t41 = $[94];
  }
  let t42;
  if ($[95] !== t) {
    t42 = t("header.top_menu.funnels");
    $[95] = t;
    $[96] = t42;
  } else {
    t42 = $[96];
  }
  const t43 = hasPermission("Funnels");
  let t44;
  if ($[97] !== regularIsActiveCheck || $[98] !== t42 || $[99] !== t43) {
    t44 = {
      name: t42,
      href: pageRoute.Funnels,
      isActive: regularIsActiveCheck,
      shouldRender: t43,
      dataTestId: "sites-funnels-link"
    };
    $[97] = regularIsActiveCheck;
    $[98] = t42;
    $[99] = t43;
    $[100] = t44;
  } else {
    t44 = $[100];
  }
  let t45;
  if ($[101] !== t) {
    t45 = t("header.top_menu.digital_stores");
    $[101] = t;
    $[102] = t45;
  } else {
    t45 = $[102];
  }
  const t46 = hasPermission("Stores");
  let t47;
  if ($[103] !== regularIsActiveCheck || $[104] !== t45 || $[105] !== t46) {
    t47 = {
      name: t45,
      href: pageRoute.Stores,
      isActive: regularIsActiveCheck,
      shouldRender: t46,
      dataTestId: "sites-digital-stores-link"
    };
    $[103] = regularIsActiveCheck;
    $[104] = t45;
    $[105] = t46;
    $[106] = t47;
  } else {
    t47 = $[106];
  }
  let t48;
  if ($[107] !== t) {
    t48 = t("header.top_menu.blogs");
    $[107] = t;
    $[108] = t48;
  } else {
    t48 = $[108];
  }
  const t49 = hasPermission("Blogs");
  let t50;
  if ($[109] !== regularIsActiveCheck || $[110] !== t48 || $[111] !== t49) {
    t50 = {
      name: t48,
      href: pageRoute.Blogs,
      isActive: regularIsActiveCheck,
      shouldRender: t49,
      dataTestId: "sites-blogs-link"
    };
    $[109] = regularIsActiveCheck;
    $[110] = t48;
    $[111] = t49;
    $[112] = t50;
  } else {
    t50 = $[112];
  }
  let t51;
  if ($[113] !== t41 || $[114] !== t44 || $[115] !== t47 || $[116] !== t50) {
    t51 = [t41, t44, t47, t50];
    $[113] = t41;
    $[114] = t44;
    $[115] = t47;
    $[116] = t50;
    $[117] = t51;
  } else {
    t51 = $[117];
  }
  let t52;
  if ($[118] !== t38 || $[119] !== t51) {
    t52 = {
      id: "sites",
      name: t38,
      dropdownItems: t51,
      mobileIconRenderer: _temp3
    };
    $[118] = t38;
    $[119] = t51;
    $[120] = t52;
  } else {
    t52 = $[120];
  }
  let t53;
  if ($[121] !== t) {
    t53 = t("header.top_menu.emails");
    $[121] = t;
    $[122] = t53;
  } else {
    t53 = $[122];
  }
  let t54;
  if ($[123] !== t) {
    t54 = t("header.top_menu.newsletters");
    $[123] = t;
    $[124] = t54;
  } else {
    t54 = $[124];
  }
  const t55 = hasPermission("Newsletters");
  let t56;
  if ($[125] !== regularIsActiveCheck || $[126] !== t54 || $[127] !== t55) {
    t56 = {
      name: t54,
      href: pageRoute.Newsletters,
      isActive: regularIsActiveCheck,
      shouldRender: t55,
      dataTestId: "emails-newsletters-link"
    };
    $[125] = regularIsActiveCheck;
    $[126] = t54;
    $[127] = t55;
    $[128] = t56;
  } else {
    t56 = $[128];
  }
  let t57;
  if ($[129] !== t) {
    t57 = t("header.top_menu.campaigns");
    $[129] = t;
    $[130] = t57;
  } else {
    t57 = $[130];
  }
  const t58 = hasPermission("Campaigns");
  let t59;
  if ($[131] !== regularIsActiveCheck || $[132] !== t57 || $[133] !== t58) {
    t59 = {
      name: t57,
      href: pageRoute.Campaigns,
      isActive: regularIsActiveCheck,
      shouldRender: t58,
      dataTestId: "emails-campaigns-link"
    };
    $[131] = regularIsActiveCheck;
    $[132] = t57;
    $[133] = t58;
    $[134] = t59;
  } else {
    t59 = $[134];
  }
  let t60;
  if ($[135] !== t) {
    t60 = t("header.top_menu.email_statistics");
    $[135] = t;
    $[136] = t60;
  } else {
    t60 = $[136];
  }
  const t61 = hasPermission("EmailStatistics");
  let t62;
  if ($[137] !== regularIsActiveCheck || $[138] !== t60 || $[139] !== t61) {
    t62 = {
      name: t60,
      href: pageRoute.EmailStatistics,
      isActive: regularIsActiveCheck,
      shouldRender: t61,
      dataTestId: "emails-statistics-link"
    };
    $[137] = regularIsActiveCheck;
    $[138] = t60;
    $[139] = t61;
    $[140] = t62;
  } else {
    t62 = $[140];
  }
  let t63;
  if ($[141] !== t56 || $[142] !== t59 || $[143] !== t62) {
    t63 = [t56, t59, t62];
    $[141] = t56;
    $[142] = t59;
    $[143] = t62;
    $[144] = t63;
  } else {
    t63 = $[144];
  }
  let t64;
  if ($[145] !== t53 || $[146] !== t63) {
    t64 = {
      id: "emails",
      name: t53,
      dropdownItems: t63,
      mobileIconRenderer: _temp4
    };
    $[145] = t53;
    $[146] = t63;
    $[147] = t64;
  } else {
    t64 = $[147];
  }
  let t65;
  if ($[148] !== t) {
    t65 = t("header.top_menu.sms");
    $[148] = t;
    $[149] = t65;
  } else {
    t65 = $[149];
  }
  let t66;
  if ($[150] !== t) {
    t66 = t("header.top_menu.sms_templates");
    $[150] = t;
    $[151] = t66;
  } else {
    t66 = $[151];
  }
  const t67 = hasPermission("SmsTemplates");
  let t68;
  if ($[152] !== regularIsActiveCheck || $[153] !== t66 || $[154] !== t67) {
    t68 = {
      name: t66,
      href: pageRoute.SmsTemplates,
      isActive: regularIsActiveCheck,
      shouldRender: t67,
      dataTestId: "sms-templates-link"
    };
    $[152] = regularIsActiveCheck;
    $[153] = t66;
    $[154] = t67;
    $[155] = t68;
  } else {
    t68 = $[155];
  }
  let t69;
  if ($[156] !== t) {
    t69 = t("header.top_menu.sms_statistics");
    $[156] = t;
    $[157] = t69;
  } else {
    t69 = $[157];
  }
  const t70 = hasPermission("SmsStatistics");
  let t71;
  if ($[158] !== regularIsActiveCheck || $[159] !== t69 || $[160] !== t70) {
    t71 = {
      name: t69,
      href: pageRoute.SmsStatistics,
      isActive: regularIsActiveCheck,
      shouldRender: t70,
      dataTestId: "sms-statistics-link"
    };
    $[158] = regularIsActiveCheck;
    $[159] = t69;
    $[160] = t70;
    $[161] = t71;
  } else {
    t71 = $[161];
  }
  let t72;
  if ($[162] !== t68 || $[163] !== t71) {
    t72 = [t68, t71];
    $[162] = t68;
    $[163] = t71;
    $[164] = t72;
  } else {
    t72 = $[164];
  }
  let t73;
  if ($[165] !== t65 || $[166] !== t72) {
    t73 = {
      id: "sms",
      name: t65,
      dropdownItems: t72,
      mobileIconRenderer: _temp5
    };
    $[165] = t65;
    $[166] = t72;
    $[167] = t73;
  } else {
    t73 = $[167];
  }
  let t74;
  if ($[168] !== t) {
    t74 = t("header.top_menu.automations");
    $[168] = t;
    $[169] = t74;
  } else {
    t74 = $[169];
  }
  let t75;
  if ($[170] !== t) {
    t75 = t("header.top_menu.rules");
    $[170] = t;
    $[171] = t75;
  } else {
    t75 = $[171];
  }
  const t76 = hasPermission("AutomationRules");
  let t77;
  if ($[172] !== regularIsActiveCheck || $[173] !== t75 || $[174] !== t76) {
    t77 = {
      name: t75,
      href: pageRoute.AutomationRules,
      isActive: regularIsActiveCheck,
      shouldRender: t76,
      dataTestId: "automations-rules-link"
    };
    $[172] = regularIsActiveCheck;
    $[173] = t75;
    $[174] = t76;
    $[175] = t77;
  } else {
    t77 = $[175];
  }
  let t78;
  if ($[176] !== t) {
    t78 = t("header.top_menu.workflows");
    $[176] = t;
    $[177] = t78;
  } else {
    t78 = $[177];
  }
  const t79 = hasPermission("Workflows");
  let t80;
  if ($[178] !== regularIsActiveCheck || $[179] !== t78 || $[180] !== t79) {
    t80 = {
      name: t78,
      href: pageRoute.Workflows,
      isActive: regularIsActiveCheck,
      shouldRender: t79,
      dataTestId: "automations-workflows-link"
    };
    $[178] = regularIsActiveCheck;
    $[179] = t78;
    $[180] = t79;
    $[181] = t80;
  } else {
    t80 = $[181];
  }
  let t81;
  if ($[182] !== t77 || $[183] !== t80) {
    t81 = [t77, t80];
    $[182] = t77;
    $[183] = t80;
    $[184] = t81;
  } else {
    t81 = $[184];
  }
  let t82;
  if ($[185] !== t74 || $[186] !== t81) {
    t82 = {
      id: "automations",
      name: t74,
      dropdownItems: t81,
      mobileIconRenderer: _temp6
    };
    $[185] = t74;
    $[186] = t81;
    $[187] = t82;
  } else {
    t82 = $[187];
  }
  let t83;
  if ($[188] !== t) {
    t83 = t("header.top_menu.products");
    $[188] = t;
    $[189] = t83;
  } else {
    t83 = $[189];
  }
  let t84;
  if ($[190] !== t) {
    t84 = t("header.top_menu.physical_product");
    $[190] = t;
    $[191] = t84;
  } else {
    t84 = $[191];
  }
  const t85 = hasPermission("Products");
  let t86;
  if ($[192] !== regularIsActiveCheck || $[193] !== t84 || $[194] !== t85) {
    t86 = {
      name: t84,
      href: pageRoute.Products,
      isActive: regularIsActiveCheck,
      shouldRender: t85,
      dataTestId: "products-physical-product-link"
    };
    $[192] = regularIsActiveCheck;
    $[193] = t84;
    $[194] = t85;
    $[195] = t86;
  } else {
    t86 = $[195];
  }
  let t87;
  if ($[196] !== t) {
    t87 = t("header.top_menu.coupons");
    $[196] = t;
    $[197] = t87;
  } else {
    t87 = $[197];
  }
  const t88 = hasPermission("Coupons");
  let t89;
  if ($[198] !== regularIsActiveCheck || $[199] !== t87 || $[200] !== t88) {
    t89 = {
      name: t87,
      href: pageRoute.Coupons,
      isActive: regularIsActiveCheck,
      shouldRender: t88,
      dataTestId: "products-coupons-link"
    };
    $[198] = regularIsActiveCheck;
    $[199] = t87;
    $[200] = t88;
    $[201] = t89;
  } else {
    t89 = $[201];
  }
  let t90;
  if ($[202] !== t) {
    t90 = t("header.top_menu.courses");
    $[202] = t;
    $[203] = t90;
  } else {
    t90 = $[203];
  }
  const t91 = hasPermission("Courses");
  let t92;
  if ($[204] !== regularIsActiveCheck || $[205] !== t90 || $[206] !== t91) {
    t92 = {
      name: t90,
      href: pageRoute.Courses,
      isActive: regularIsActiveCheck,
      shouldRender: t91,
      dataTestId: "products-courses-link"
    };
    $[204] = regularIsActiveCheck;
    $[205] = t90;
    $[206] = t91;
    $[207] = t92;
  } else {
    t92 = $[207];
  }
  let t93;
  if ($[208] !== t) {
    t93 = t("header.top_menu.communities");
    $[208] = t;
    $[209] = t93;
  } else {
    t93 = $[209];
  }
  const t94 = hasPermission("Communities");
  let t95;
  if ($[210] !== regularIsActiveCheck || $[211] !== t93 || $[212] !== t94) {
    t95 = {
      name: t93,
      href: pageRoute.Communities,
      isActive: regularIsActiveCheck,
      shouldRender: t94,
      dataTestId: "products-communities-link"
    };
    $[210] = regularIsActiveCheck;
    $[211] = t93;
    $[212] = t94;
    $[213] = t95;
  } else {
    t95 = $[213];
  }
  let t96;
  if ($[214] !== t) {
    t96 = t("header.top_menu.files");
    $[214] = t;
    $[215] = t96;
  } else {
    t96 = $[215];
  }
  const t97 = hasPermission("Files");
  let t98;
  if ($[216] !== regularIsActiveCheck || $[217] !== t96 || $[218] !== t97) {
    t98 = {
      name: t96,
      href: pageRoute.Files,
      isActive: regularIsActiveCheck,
      shouldRender: t97,
      dataTestId: "products-files-link"
    };
    $[216] = regularIsActiveCheck;
    $[217] = t96;
    $[218] = t97;
    $[219] = t98;
  } else {
    t98 = $[219];
  }
  let t99;
  if ($[220] !== t86 || $[221] !== t89 || $[222] !== t92 || $[223] !== t95 || $[224] !== t98) {
    t99 = [t86, t89, t92, t95, t98];
    $[220] = t86;
    $[221] = t89;
    $[222] = t92;
    $[223] = t95;
    $[224] = t98;
    $[225] = t99;
  } else {
    t99 = $[225];
  }
  let t100;
  if ($[226] !== t83 || $[227] !== t99) {
    t100 = {
      id: "products",
      name: t83,
      dropdownItems: t99,
      mobileIconRenderer: _temp7
    };
    $[226] = t83;
    $[227] = t99;
    $[228] = t100;
  } else {
    t100 = $[228];
  }
  let t101;
  if ($[229] !== t) {
    t101 = t("header.top_menu.sales");
    $[229] = t;
    $[230] = t101;
  } else {
    t101 = $[230];
  }
  let t102;
  if ($[231] !== t) {
    t102 = t("header.top_menu.orders");
    $[231] = t;
    $[232] = t102;
  } else {
    t102 = $[232];
  }
  const t103 = hasPermission("Orders");
  let t104;
  if ($[233] !== regularIsActiveCheck || $[234] !== t102 || $[235] !== t103) {
    t104 = {
      name: t102,
      href: pageRoute.Orders,
      isActive: regularIsActiveCheck,
      shouldRender: t103,
      dataTestId: "sales-orders-link"
    };
    $[233] = regularIsActiveCheck;
    $[234] = t102;
    $[235] = t103;
    $[236] = t104;
  } else {
    t104 = $[236];
  }
  let t105;
  if ($[237] !== t) {
    t105 = t("header.top_menu.transactions");
    $[237] = t;
    $[238] = t105;
  } else {
    t105 = $[238];
  }
  const t106 = hasPermission("Transactions");
  let t107;
  if ($[239] !== regularIsActiveCheck || $[240] !== t105 || $[241] !== t106) {
    t107 = {
      name: t105,
      href: pageRoute.Transactions,
      isActive: regularIsActiveCheck,
      shouldRender: t106,
      dataTestId: "sales-transactions-link"
    };
    $[239] = regularIsActiveCheck;
    $[240] = t105;
    $[241] = t106;
    $[242] = t107;
  } else {
    t107 = $[242];
  }
  let t108;
  if ($[243] !== t) {
    t108 = t("header.top_menu.subscriptions");
    $[243] = t;
    $[244] = t108;
  } else {
    t108 = $[244];
  }
  const t109 = hasPermission("Subscriptions");
  let t110;
  if ($[245] !== regularIsActiveCheck || $[246] !== t108 || $[247] !== t109) {
    t110 = {
      name: t108,
      href: pageRoute.Subscriptions,
      isActive: regularIsActiveCheck,
      shouldRender: t109,
      dataTestId: "sales-subscriptions-link"
    };
    $[245] = regularIsActiveCheck;
    $[246] = t108;
    $[247] = t109;
    $[248] = t110;
  } else {
    t110 = $[248];
  }
  let t111;
  if ($[249] !== t) {
    t111 = t("header.top_menu.affiliate_invoices");
    $[249] = t;
    $[250] = t111;
  } else {
    t111 = $[250];
  }
  const t112 = hasPermission("AffiliateInvoices");
  let t113;
  if ($[251] !== regularIsActiveCheck || $[252] !== t111 || $[253] !== t112) {
    t113 = {
      name: t111,
      href: pageRoute.AffiliateInvoices,
      shouldRender: t112,
      isActive: regularIsActiveCheck,
      dataTestId: "sales-affiliate-invoices-link"
    };
    $[251] = regularIsActiveCheck;
    $[252] = t111;
    $[253] = t112;
    $[254] = t113;
  } else {
    t113 = $[254];
  }
  let t114;
  if ($[255] !== t) {
    t114 = t("header.top_menu.affiliate_program");
    $[255] = t;
    $[256] = t114;
  } else {
    t114 = $[256];
  }
  const t115 = hasPermission("AffiliateProgram");
  let t116;
  if ($[257] !== regularIsActiveCheck || $[258] !== t114 || $[259] !== t115) {
    t116 = {
      name: t114,
      href: pageRoute.AffiliateProgram,
      shouldRender: t115,
      isActive: regularIsActiveCheck,
      dataTestId: "sales-affiliate-program-link"
    };
    $[257] = regularIsActiveCheck;
    $[258] = t114;
    $[259] = t115;
    $[260] = t116;
  } else {
    t116 = $[260];
  }
  let t117;
  if ($[261] !== t104 || $[262] !== t107 || $[263] !== t110 || $[264] !== t113 || $[265] !== t116) {
    t117 = [t104, t107, t110, t113, t116];
    $[261] = t104;
    $[262] = t107;
    $[263] = t110;
    $[264] = t113;
    $[265] = t116;
    $[266] = t117;
  } else {
    t117 = $[266];
  }
  let t118;
  if ($[267] !== t101 || $[268] !== t117) {
    t118 = {
      id: "sales",
      name: t101,
      dropdownItems: t117,
      mobileIconRenderer: _temp8
    };
    $[267] = t101;
    $[268] = t117;
    $[269] = t118;
  } else {
    t118 = $[269];
  }
  let t119;
  if ($[270] !== t) {
    t119 = t("header.top_menu.admin.admin");
    $[270] = t;
    $[271] = t119;
  } else {
    t119 = $[271];
  }
  let t120;
  if ($[272] !== t) {
    t120 = t("header.top_menu.admin.users");
    $[272] = t;
    $[273] = t120;
  } else {
    t120 = $[273];
  }
  const t121 = hasPermission("AdminUsers");
  let t122;
  if ($[274] !== regularIsActiveCheck || $[275] !== t120 || $[276] !== t121) {
    t122 = {
      name: t120,
      href: pageRoute.AdminUsers,
      shouldRender: t121,
      isActive: regularIsActiveCheck,
      dataTestId: "admin-users-link"
    };
    $[274] = regularIsActiveCheck;
    $[275] = t120;
    $[276] = t121;
    $[277] = t122;
  } else {
    t122 = $[277];
  }
  let t123;
  if ($[278] !== t) {
    t123 = t("header.top_menu.admin.templates");
    $[278] = t;
    $[279] = t123;
  } else {
    t123 = $[279];
  }
  let t124;
  if ($[280] !== t) {
    t124 = t("header.top_menu.admin.email_templates");
    $[280] = t;
    $[281] = t124;
  } else {
    t124 = $[281];
  }
  const t125 = hasPermission("AdminEmailTemplates");
  let t126;
  if ($[282] !== regularIsActiveCheck || $[283] !== t124 || $[284] !== t125) {
    t126 = {
      name: t124,
      href: pageRoute.AdminEmailTemplates,
      isActive: regularIsActiveCheck,
      shouldRender: t125,
      dataTestId: "admin-templates-email-templates-link"
    };
    $[282] = regularIsActiveCheck;
    $[283] = t124;
    $[284] = t125;
    $[285] = t126;
  } else {
    t126 = $[285];
  }
  let t127;
  if ($[286] !== t) {
    t127 = t("header.top_menu.admin.page_templates");
    $[286] = t;
    $[287] = t127;
  } else {
    t127 = $[287];
  }
  const t128 = hasPermission("AdminPageTemplates");
  let t129;
  if ($[288] !== regularIsActiveCheck || $[289] !== t127 || $[290] !== t128) {
    t129 = {
      name: t127,
      href: pageRoute.AdminPageTemplates,
      isActive: regularIsActiveCheck,
      shouldRender: t128,
      dataTestId: "admin-templates-page-templates-link"
    };
    $[288] = regularIsActiveCheck;
    $[289] = t127;
    $[290] = t128;
    $[291] = t129;
  } else {
    t129 = $[291];
  }
  let t130;
  if ($[292] !== t) {
    t130 = t("header.top_menu.admin.blog_templates");
    $[292] = t;
    $[293] = t130;
  } else {
    t130 = $[293];
  }
  const t131 = hasPermission("AdminBlogTemplates");
  let t132;
  if ($[294] !== regularIsActiveCheck || $[295] !== t130 || $[296] !== t131) {
    t132 = {
      name: t130,
      href: pageRoute.AdminBlogTemplates,
      isActive: regularIsActiveCheck,
      shouldRender: t131,
      dataTestId: "admin-templates-blog-templates-link"
    };
    $[294] = regularIsActiveCheck;
    $[295] = t130;
    $[296] = t131;
    $[297] = t132;
  } else {
    t132 = $[297];
  }
  let t133;
  if ($[298] !== t) {
    t133 = t("header.top_menu.admin.website_templates");
    $[298] = t;
    $[299] = t133;
  } else {
    t133 = $[299];
  }
  const t134 = hasPermission("AdminWebsiteTemplates");
  let t135;
  if ($[300] !== regularIsActiveCheck || $[301] !== t133 || $[302] !== t134) {
    t135 = {
      name: t133,
      href: pageRoute.AdminWebsiteTemplates,
      shouldRender: t134,
      isActive: regularIsActiveCheck,
      dataTestId: "admin-templates-website-templates-link"
    };
    $[300] = regularIsActiveCheck;
    $[301] = t133;
    $[302] = t134;
    $[303] = t135;
  } else {
    t135 = $[303];
  }
  let t136;
  if ($[304] !== t) {
    t136 = t("header.top_menu.admin.funnel_templates");
    $[304] = t;
    $[305] = t136;
  } else {
    t136 = $[305];
  }
  const t137 = hasPermission("AdminFunnelTemplates");
  let t138;
  if ($[306] !== regularIsActiveCheck || $[307] !== t136 || $[308] !== t137) {
    t138 = {
      name: t136,
      href: pageRoute.AdminFunnelTemplates,
      isActive: regularIsActiveCheck,
      shouldRender: t137,
      dataTestId: "admin-templates-funnel-templates-link"
    };
    $[306] = regularIsActiveCheck;
    $[307] = t136;
    $[308] = t137;
    $[309] = t138;
  } else {
    t138 = $[309];
  }
  let t139;
  if ($[310] !== t126 || $[311] !== t129 || $[312] !== t132 || $[313] !== t135 || $[314] !== t138) {
    t139 = [t126, t129, t132, t135, t138];
    $[310] = t126;
    $[311] = t129;
    $[312] = t132;
    $[313] = t135;
    $[314] = t138;
    $[315] = t139;
  } else {
    t139 = $[315];
  }
  let t140;
  if ($[316] !== t123 || $[317] !== t139) {
    t140 = {
      id: "admin-templates",
      name: t123,
      dropdownItems: t139
    };
    $[316] = t123;
    $[317] = t139;
    $[318] = t140;
  } else {
    t140 = $[318];
  }
  let t141;
  if ($[319] !== t) {
    t141 = t("header.top_menu.admin.customers");
    $[319] = t;
    $[320] = t141;
  } else {
    t141 = $[320];
  }
  const t142 = hasPermission("AdminCustomers");
  let t143;
  if ($[321] !== regularIsActiveCheck || $[322] !== t141 || $[323] !== t142) {
    t143 = {
      name: t141,
      href: pageRoute.AdminCustomers,
      shouldRender: t142,
      isActive: regularIsActiveCheck,
      dataTestId: "admin-customers-link"
    };
    $[321] = regularIsActiveCheck;
    $[322] = t141;
    $[323] = t142;
    $[324] = t143;
  } else {
    t143 = $[324];
  }
  let t144;
  if ($[325] !== t) {
    t144 = t("header.top_menu.admin.emails");
    $[325] = t;
    $[326] = t144;
  } else {
    t144 = $[326];
  }
  const t145 = hasPermission("AdminEmailStats");
  let t146;
  if ($[327] !== regularIsActiveCheck || $[328] !== t144 || $[329] !== t145) {
    t146 = {
      name: t144,
      href: pageRoute.AdminEmailStats,
      shouldRender: t145,
      isActive: regularIsActiveCheck,
      dataTestId: "admin-emails-link"
    };
    $[327] = regularIsActiveCheck;
    $[328] = t144;
    $[329] = t145;
    $[330] = t146;
  } else {
    t146 = $[330];
  }
  let t147;
  if ($[331] !== t) {
    t147 = t("header.top_menu.admin.user_plans");
    $[331] = t;
    $[332] = t147;
  } else {
    t147 = $[332];
  }
  const t148 = hasPermission("AdminUserPlans");
  let t149;
  if ($[333] !== regularIsActiveCheck || $[334] !== t147 || $[335] !== t148) {
    t149 = {
      name: t147,
      href: pageRoute.AdminUserPlans,
      shouldRender: t148,
      isActive: regularIsActiveCheck,
      dataTestId: "admin-user-plans-link"
    };
    $[333] = regularIsActiveCheck;
    $[334] = t147;
    $[335] = t148;
    $[336] = t149;
  } else {
    t149 = $[336];
  }
  let t150;
  if ($[337] !== t) {
    t150 = t("header.top_menu.admin.domains_blocked");
    $[337] = t;
    $[338] = t150;
  } else {
    t150 = $[338];
  }
  const t151 = hasPermission("AdminDomainsBlocked");
  let t152;
  if ($[339] !== regularIsActiveCheck || $[340] !== t150 || $[341] !== t151) {
    t152 = {
      name: t150,
      href: pageRoute.AdminDomainsBlocked,
      shouldRender: t151,
      isActive: regularIsActiveCheck,
      dataTestId: "admin-domains-blocked-link"
    };
    $[339] = regularIsActiveCheck;
    $[340] = t150;
    $[341] = t151;
    $[342] = t152;
  } else {
    t152 = $[342];
  }
  let t153;
  if ($[343] !== t) {
    t153 = t("header.top_menu.admin.domains_white_listed");
    $[343] = t;
    $[344] = t153;
  } else {
    t153 = $[344];
  }
  const t154 = hasPermission("AdminDomainsWhitelist");
  let t155;
  if ($[345] !== regularIsActiveCheck || $[346] !== t153 || $[347] !== t154) {
    t155 = {
      name: t153,
      href: pageRoute.AdminDomainsWhitelist,
      shouldRender: t154,
      isActive: regularIsActiveCheck,
      dataTestId: "admin-domains-whitelisted-link"
    };
    $[345] = regularIsActiveCheck;
    $[346] = t153;
    $[347] = t154;
    $[348] = t155;
  } else {
    t155 = $[348];
  }
  let t156;
  if ($[349] !== t) {
    t156 = t("header.top_menu.admin.suspicious_content");
    $[349] = t;
    $[350] = t156;
  } else {
    t156 = $[350];
  }
  let t157;
  if ($[351] !== t) {
    t157 = t("header.top_menu.admin.suspicious_page_content_keywords");
    $[351] = t;
    $[352] = t157;
  } else {
    t157 = $[352];
  }
  const t158 = hasPermission("AdminSuspiciousPageKeywords");
  let t159;
  if ($[353] !== regularIsActiveCheck || $[354] !== t157 || $[355] !== t158) {
    t159 = {
      name: t157,
      href: pageRoute.AdminSuspiciousPageKeywords,
      isActive: regularIsActiveCheck,
      shouldRender: t158,
      dataTestId: "admin-suspicious-content-page-keywords-link"
    };
    $[353] = regularIsActiveCheck;
    $[354] = t157;
    $[355] = t158;
    $[356] = t159;
  } else {
    t159 = $[356];
  }
  let t160;
  if ($[357] !== t) {
    t160 = t("header.top_menu.admin.suspicious_email_keywords");
    $[357] = t;
    $[358] = t160;
  } else {
    t160 = $[358];
  }
  const t161 = hasPermission("AdminSuspiciousEmailKeywords");
  let t162;
  if ($[359] !== regularIsActiveCheck || $[360] !== t160 || $[361] !== t161) {
    t162 = {
      name: t160,
      href: pageRoute.AdminSuspiciousEmailKeywords,
      isActive: regularIsActiveCheck,
      shouldRender: t161,
      dataTestId: "admin-suspicious-content-email-keywords-link"
    };
    $[359] = regularIsActiveCheck;
    $[360] = t160;
    $[361] = t161;
    $[362] = t162;
  } else {
    t162 = $[362];
  }
  let t163;
  if ($[363] !== t) {
    t163 = t("header.top_menu.admin.suspicious_email_address");
    $[363] = t;
    $[364] = t163;
  } else {
    t163 = $[364];
  }
  const t164 = hasPermission("AdminSuspiciousEmailAddress");
  let t165;
  if ($[365] !== regularIsActiveCheck || $[366] !== t163 || $[367] !== t164) {
    t165 = {
      name: t163,
      href: pageRoute.AdminSuspiciousEmailAddress,
      isActive: regularIsActiveCheck,
      shouldRender: t164,
      dataTestId: "admin-suspicious-content-email-address-link"
    };
    $[365] = regularIsActiveCheck;
    $[366] = t163;
    $[367] = t164;
    $[368] = t165;
  } else {
    t165 = $[368];
  }
  let t166;
  if ($[369] !== t159 || $[370] !== t162 || $[371] !== t165) {
    t166 = [t159, t162, t165];
    $[369] = t159;
    $[370] = t162;
    $[371] = t165;
    $[372] = t166;
  } else {
    t166 = $[372];
  }
  let t167;
  if ($[373] !== t156 || $[374] !== t166) {
    t167 = {
      id: "admin-suspicious-content",
      name: t156,
      dropdownItems: t166
    };
    $[373] = t156;
    $[374] = t166;
    $[375] = t167;
  } else {
    t167 = $[375];
  }
  let t168;
  if ($[376] !== t) {
    t168 = t("header.top_menu.admin.statistics");
    $[376] = t;
    $[377] = t168;
  } else {
    t168 = $[377];
  }
  const t169 = hasPermission("AdminStatistics");
  let t170;
  if ($[378] !== regularIsActiveCheck || $[379] !== t168 || $[380] !== t169) {
    t170 = {
      name: t168,
      href: pageRoute.AdminStatistics,
      shouldRender: t169,
      isActive: regularIsActiveCheck,
      dataTestId: "admin-statistics-link"
    };
    $[378] = regularIsActiveCheck;
    $[379] = t168;
    $[380] = t169;
    $[381] = t170;
  } else {
    t170 = $[381];
  }
  let t171;
  if ($[382] !== t122 || $[383] !== t140 || $[384] !== t143 || $[385] !== t146 || $[386] !== t149 || $[387] !== t152 || $[388] !== t155 || $[389] !== t167 || $[390] !== t170) {
    t171 = [t122, t140, t143, t146, t149, t152, t155, t167, t170];
    $[382] = t122;
    $[383] = t140;
    $[384] = t143;
    $[385] = t146;
    $[386] = t149;
    $[387] = t152;
    $[388] = t155;
    $[389] = t167;
    $[390] = t170;
    $[391] = t171;
  } else {
    t171 = $[391];
  }
  let t172;
  if ($[392] !== t119 || $[393] !== t171) {
    t172 = {
      id: "admin",
      name: t119,
      dropdownItems: t171,
      mobileIconRenderer: _temp9
    };
    $[392] = t119;
    $[393] = t171;
    $[394] = t172;
  } else {
    t172 = $[394];
  }
  let t173;
  if ($[395] !== t100 || $[396] !== t118 || $[397] !== t172 || $[398] !== t18 || $[399] !== t37 || $[400] !== t52 || $[401] !== t64 || $[402] !== t73 || $[403] !== t82) {
    t173 = [t18, t37, t52, t64, t73, t82, t100, t118, t172];
    $[395] = t100;
    $[396] = t118;
    $[397] = t172;
    $[398] = t18;
    $[399] = t37;
    $[400] = t52;
    $[401] = t64;
    $[402] = t73;
    $[403] = t82;
    $[404] = t173;
  } else {
    t173 = $[404];
  }
  const menuItems = t173;
  let t174;
  if ($[405] !== isReady || $[406] !== menuItems) {
    t174 = {
      menuItems,
      isReady
    };
    $[405] = isReady;
    $[406] = menuItems;
    $[407] = t174;
  } else {
    t174 = $[407];
  }
  return t174;
};
function _temp() {
  return <HomeLineIcon />;
}
function _temp2() {
  return <User03Icon />;
}
function _temp3() {
  return <BrowserIcon />;
}
function _temp4() {
  return <Mail04Icon />;
}
function _temp5() {
  return <MessageDotsSquareIcon />;
}
function _temp6() {
  return <GitPullRequestIcon />;
}
function _temp7() {
  return <FileAttachment01Icon />;
}
function _temp8() {
  return <Sale01Icon />;
}
function _temp9() {
  return <AdminIcon />;
}